import { createSlice } from '@reduxjs/toolkit'
import { getFurniture, saveFurniture, createFurniture, deleteFurniture } from './furnitureActions'

const initialState = {
  furniture: [],
  loading: false,
  error: false,
  loadingError: false,
  savingError: false,
  saving: false,
  saved: false,
  savedFurniture: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}

const furnitureSlice = createSlice({
  name: 'furniture',
  initialState,
  reducers: {
    clear: (state) => {
      state.saved = false
      state.savingError = false
      state.loadingError = false
      state.savedFurniture = {}
      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getFurniture.fulfilled, (state, { payload }) => {
        state.loading = false
        state.furniture = payload
      })
      .addCase(getFurniture.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(saveFurniture.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveFurniture.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.furniture[state.furniture.findIndex((p) => p.id === payload.id)] = payload
        state.savedFurniture = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveFurniture.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createFurniture.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createFurniture.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedFurniture = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createFurniture.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteFurniture.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteFurniture.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteFurniture.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
      .addMatcher(
        isRejectedAction,
        // `action` will be inferred as a RejectedAction due to isRejectedAction being defined as a type guard
        (state, { payload }) => {
          state.loading = false
          state.error = payload
        },
      )
  },
})
export const { clear } = furnitureSlice.actions
export default furnitureSlice.reducer
